import { useTranslation } from 'react-i18next';
import { ConfirmationDialog, Typography } from '@statsbomb/kitbag-components';
import { Suspense, useState } from 'react';
import { FirstTimeModalWithData } from '@/components/modal/FirstTimeModals/FirstTimeModal';
import { FirstTimeModalTypes } from '@/types/userConfigs';

export const FirstTimeModalExploreBase = ({
  onConfirm,
  entity,
}: {
  onConfirm: () => void;
  entity: 'team' | 'event';
}) => {
  const { t } = useTranslation(['modal', 'entity']);

  return (
    <ConfirmationDialog
      id="first-time-explore-modal"
      title={t('firstTimeModalExplore.title')}
      isOpen
      onConfirm={onConfirm}
      confirmLabel={t('firstTimeModalExplore.confirm')}
      testId="first-time-explore-modal"
    >
      <div className="w-[680px]">
        <Typography variant="bodyRegular">
          {t('firstTimeModalExplore.content.0')}
          <span className="font-bold">
            {t('firstTimeModalExplore.content.1').replace(
              '{{entity}}',
              t(`${entity}.oneSentenceCase`, { ns: 'entity' }),
            )}{' '}
          </span>
          {t('firstTimeModalExplore.content.2').replace(
            '{{selectionOfEventTypes}}',
            t(`firstTimeModalExplore.selectionOfEventTypes.${entity}`),
          )}
          <br />
          <br />
          {t('firstTimeModalExplore.content.3')}
          <span className="font-bold">{t('firstTimeModalExplore.content.4')} </span>
          {t('firstTimeModalExplore.content.5')}
          <span className="font-bold"> {t('firstTimeModalExplore.content.6')} </span>
          {t('firstTimeModalExplore.content.7')}
        </Typography>
      </div>
    </ConfirmationDialog>
  );
};

export const FirstTimeModalExplore = ({
  entity,
  modalType,
}: {
  entity: 'team' | 'event';
  modalType: FirstTimeModalTypes;
}) => {
  const [userHasAcknowledgedModal, setUserHasAcknowledgedModal] = useState(false);

  return userHasAcknowledgedModal ? null : (
    <Suspense>
      <FirstTimeModalWithData modalType={modalType}>
        <FirstTimeModalExploreBase entity={entity} onConfirm={() => setUserHasAcknowledgedModal(true)} />
      </FirstTimeModalWithData>
    </Suspense>
  );
};
